import React from "react";

//Utils
import { mapServices } from "../../../../Utils/Utils";

//Images
import driveways from "../images/services/services-driveways.jpg";
import patios from "../images/services/services-patios.jpg";
import pools from "../images/services/services-pools.jpg";
import gardenWalls from "../images/services/services-garden-walls.jpg";
import steps from "../images/services/services-steps-and-coping.jpg";
import walkways from "../images/services/services-walkways.jpg";
// import firefeatures from "../images/services/services-firefeatures.jpg";

export const SERVICES = [
  {
    title: "Patios",
    image: patios,
    destination: "/services/patios",
    categories: ["services"],
  },
  {
    title: "Driveways",
    image: driveways,
    destination: "/services/driveways",
    categories: ["services"],
  },
  {
    title: "Garden Walls",
    image: gardenWalls,
    destination: "/services/garden-walls",
    categories: ["services"],
  },
  {
    title: "Pool Decks",
    image: pools,
    destination: "/services/pool-decks",
    categories: ["services"],
  },
  {
    title: "Steps and Coping",
    image: steps,
    destination: "/services/steps-and-coping",
    categories: ["services"],
  },
  {
    title: "Walkways",
    image: walkways,
    destination: "/services/walkways",
    categories: ["services"],
  },
  // {
  //   title: "Fire Features",
  //   image: firefeatures,
  //   destination: "/services/firefeatures",
  //   categories: ['services'],
  // },
];

const Services = () => {
  return (
    <div className="row justify-content-center">
      <div className="col-11 col-xl-10 no-side-padding panel-services">
        <div className="row justify-content-center">
          <div className="col-11 text-center">
            <h3 className="text-blue mb-3">
              Southern California’s #1 one-stop-shop for new Driveways, Pool
              Decks, Patios and more, since 1999.
            </h3>
          </div>
        </div>
        <div className="row justify-content-center services-list">
          {mapServices(SERVICES)}
        </div>
      </div>
    </div>
  );
};

export default Services;
